import React, { useEffect } from 'react';

import { IMessageComplete, IIncommingInfo } from '../../../hooks/Messages';
import { useConfiguration } from '../../../hooks/Configuration';

export interface IIncommingInfoProps extends IIncommingInfo {
    message: IMessageComplete
    scrollToBottom: () => void
}

function IncommingInfo({ text, message, scrollToBottom }: IIncommingInfoProps) {
    const configuration = useConfiguration();

    useEffect(
        () => {
            scrollToBottom();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <div
            className='stx-chat-info'
            style={{
                color: configuration?.styles.messageInfoColor
            }}>
            {text}
        </div>
    );
}

export default IncommingInfo;
